import { render, staticRenderFns } from "./payments_data_grid.vue?vue&type=template&id=9cce0ca6&scoped=true&"
import script from "./payments_data_grid.vue?vue&type=script&lang=js&"
export * from "./payments_data_grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cce0ca6",
  null
  
)

export default component.exports